export const theme = {
  primary: "#3F2860",
  accent: "#D56048",
  bg: "#FAFAFA",
  grey: "#4B5457",
  hero: "rgb(251, 247, 243)",
  surfaceRaised3: "#E4DFE9"
};

export const brandColors = {
  purple: "#3F2860",
  purpleLight: "#E4DFE9",
  yellow: "#FFC53F",
  orange: "#F3753A",
  pink: "#F599B5",
  cream: "#F5F3E3",
  deepBlue: "#28425B"
};
